import { useCallback, useEffect, useRef, useState } from "react";

const resolveContextMenuTarget = (target) => {
  if (!target?.closest) return target;

  const smartArtEl = target.closest(".smartart");
  if (smartArtEl) return smartArtEl;

  const wordArtEl = target.closest(".wordart");
  if (wordArtEl) return wordArtEl;

  let current = target;
  while (current) {
    const id = typeof current.id === "string" ? current.id : "";
    if (current.getAttribute?.("data-id")) return current;
    if (
      id.includes("smartart") ||
      id.includes("wordart") ||
      id.includes("shape") ||
      id.includes("image") ||
      /title|layout/i.test(id) ||
      (id.includes("text") && !id.includes("wordart"))
    ) {
      return current;
    }
    const parentId =
      typeof current.parentElement?.id === "string" ? current.parentElement.id : "";
    if (parentId.includes("image") || parentId.includes("shape") || parentId.includes("wordart")) {
      return current;
    }
    current = current.parentElement;
  }

  return target;
};

const useContextMenu = () => {
  const elemRef = useRef();
  const [showMenu, setShowMenu] = useState({
    xPos: "0px",
    yPos: "0px",
    show: false,
    disable: false,
  });

  const handleContextMenu = useCallback((e) => {
    e.preventDefault();

    const target = resolveContextMenuTarget(e?.target);
    elemRef.current = target;

    const id = typeof target?.id === "string" ? target.id : "";
    const dataId =
      typeof target?.getAttribute === "function" ? target.getAttribute("data-id") : null;
    const parentId =
      typeof target?.parentElement?.id === "string" ? target.parentElement.id : "";

    const isElementActionable =
      Boolean(dataId) ||
      /title|text|layout|image|wordart|smartart/i.test(id) ||
      parentId.includes("image") ||
      parentId.includes("shape") ||
      parentId.includes("wordart") ||
      target?.classList?.contains("wordart") ||
      target?.classList?.contains("smartart");

    setShowMenu({
      xPos: `${e.clientX}px`,
      yPos: `${e.clientY}px`,
      show: true,
      disable: !isElementActionable,
    });
  }, []);

  const handleClick = useCallback(() => {
    setShowMenu((prev) => (prev.show ? { ...prev, show: false, disable: false } : prev));
  }, []);

  useEffect(() => {
    document.addEventListener("click", handleClick);
    document.addEventListener("contextmenu", handleContextMenu);
    return () => {
      document.removeEventListener("click", handleClick);
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, [handleClick, handleContextMenu]);

  return { showMenu, elemRef };
};

export default useContextMenu;
